window.ScreenXS = 580;
window.ScreenSM = 768;
window.ScreenMD = 980;
window.ScreenLG = 1200;
window.ScreenXL = 1400;
